import React, { useEffect, useState } from "react";
import GenericCrudPage from "../common/GenericCrudPage";
import { getSubjects, createSubject, updateSubject, deleteSubject } from "../../../services/SubjectService";
import { getDepartments } from "../../../services/DepartmentService";
import { getLevels } from "../../../services/LevelService";
import { useTranslation } from "react-i18next";

const Subjects = () => {
  const { t } = useTranslation();
  const [departments, setDepartments] = useState([]);
  const [levels, setLevels] = useState([]);

  useEffect(() => {
    getDepartments({ page: 1, limit: 200 })
      .then((res) => setDepartments(res.data?.data || []))
      .catch(() => {});
    getLevels({ page: 1, limit: 200 })
      .then((res) => setLevels(res.data?.data || []))
      .catch(() => {});
  }, []);

  const departmentLabel = (id) => departments.find((d) => d.id === id)?.name || "-";
  const levelLabel = (id) => levels.find((l) => l.id === id)?.name || "-";

  return (
    <GenericCrudPage
      permissionModule="SUBJECT"
      title={t("pages.subjects.title")}
      breadcrumbLabel={t("menu.subjects.title")}
      addLabel={t("pages.subjects.addLabel")}
      searchPlaceholder={t("common.ui.rechercherCodeNom")}
      defaultSort={{ by: "name", dir: "asc" }}
      api={{
        list: getSubjects,
        create: createSubject,
        update: updateSubject,
        remove: deleteSubject,
      }}
      filters={[
        {
          key: "department_id",
          label: t("common.fields.allDepartments"),
          options: departments.map((d) => ({ value: d.id, label: d.name })),
        },
      ]}
      columns={[
        { key: "code", label: t("common.fields.code"), sortable: true },
        { key: "name", label: t("common.fields.name"), sortable: true },
        { key: "department_id", label: t("common.fields.department"), render: (row) => departmentLabel(row.department_id) },
        { key: "level_id", label: t("common.fields.level"), render: (row) => (row.level_id ? levelLabel(row.level_id) : "-") },
        { key: "coefficient", label: t("pages.subjects.coefficientShort"), render: (row) => row.coefficient ?? "-" },
        { key: "credits", label: t("pages.subjects.credits"), render: (row) => row.credits ?? "-" },
      ]}
      fields={[
        {
          key: "department_id",
          label: t("common.fields.department"),
          type: "select",
          required: true,
          options: departments.map((d) => ({ value: d.id, label: d.name })),
        },
        {
          key: "level_id",
          label: t("pages.subjects.levelOptional"),
          type: "select",
          options: levels.map((l) => ({ value: l.id, label: l.name })),
        },
        { key: "code", label: t("common.fields.code"), type: "text", required: true, placeholder: "MATH101", maxLength: 30 },
        { key: "name", label: t("common.fields.name"), type: "text", required: true, placeholder: t("pages.subjects.mathematiquesI"), maxLength: 150 },
        { key: "coefficient", label: t("pages.subjects.coefficient"), type: "number", placeholder: "1" },
        { key: "credits", label: t("pages.subjects.credits"), type: "number", placeholder: "3" },
        { key: "description", label: t("common.fields.description"), type: "textarea" },
        { key: "is_active", label: t("common.crud.statusActive"), type: "checkbox" },
      ]}
      buildPayload={(formData) => ({
        department_id: formData.department_id,
        level_id: formData.level_id || null,
        code: formData.code.trim(),
        name: formData.name.trim(),
        coefficient: formData.coefficient !== "" ? Number(formData.coefficient) : undefined,
        credits: formData.credits !== "" ? Number(formData.credits) : undefined,
        description: formData.description?.trim() || null,
        is_active: formData.is_active !== undefined ? !!formData.is_active : true,
      })}
      getItemLabel={(item) => item.name}
    />
  );
};

export default Subjects;
